import { useMemo, useState } from "react";
import { Alert, Button, Col, Row, Space } from "antd";
import CopyOutlined from "@ant-design/icons/CopyOutlined";
import EyeInvisibleOutlined from "@ant-design/icons/EyeInvisibleOutlined";
import EyeOutlined from "@ant-design/icons/EyeOutlined";
import HomeOutlined from "@ant-design/icons/HomeOutlined";
import { useRouteError } from "react-router";
import { Link } from "react-router-dom";

import { useReloadUpdatedApp } from "./useReloadUpdatedApp";
import { ErrorScreen } from "@components/ErrorScreen";
import { useClipboard } from "@hooks/useClipboard";

export const ErrorBoundaryRoot = () => {
  const error = useRouteError();

  const [showError, setShowError] = useState(false);

  const errorMsg = useMemo(() => {
    if (error) {
      if (typeof error === "string") {
        return error;
      } else if (typeof error === "object") {
        if ("message" in error && typeof error.message === "string") {
          return error.message;
        }
      }
    }

    return "";
  }, [error]);

  const { copyText } = useClipboard();
  const copyError = () => copyText(errorMsg, "Erro copiado.");

  const reloadUpdatedApp = useReloadUpdatedApp(errorMsg);
  if (reloadUpdatedApp) return reloadUpdatedApp;

  return (
    <ErrorScreen title="Oops." subtitle="Algo errado aconteceu!">
      <Row gutter={[8, 8]}>
        <Col>
          <Link to="/">
            <Button type="primary" icon={<HomeOutlined />}>
              Voltar ao início
            </Button>
          </Link>
        </Col>
        <Col>
          <Button
            type="primary"
            icon={showError ? <EyeInvisibleOutlined /> : <EyeOutlined />}
            onClick={() => setShowError((isShowing) => !isShowing)}
            ghost
          >
            {showError ? "Ocultar" : "Exibir"} erro
          </Button>
        </Col>
      </Row>
      {showError && (
        <Space direction="vertical" align="end">
          <Alert
            style={{ maxWidth: 800 }}
            message={errorMsg}
            type="warning"
            showIcon
          />

          <Button
            type="primary"
            icon={<CopyOutlined />}
            onClick={copyError}
            ghost
          >
            Copiar erro
          </Button>
        </Space>
      )}
    </ErrorScreen>
  );
};
